$(document).ready(function () {
 
  if($('.banners_list .banner-slide').length > 1){  
    $('.banners_list').slick({
      arrows: true,
      dots: false,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 500,
      slidesToShow: 1,
      adaptiveHeight: true
    });
  }


  $('.header-top-mobile').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1
  });
  
  $(".reviews-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  
  $('.collection_slider_tab .product-slider').slick({
    arrows: true,
    infinite: false,
    dots: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
});

$(".down-scroll-box .down-scroll").click(function(e) {
      e.preventDefault();
      var id=$(this).attr('href');
      $('html, body').animate({
          scrollTop: $(id).offset().top
      }, 1000);
  });

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.products-slider-section .product-slider').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  
  $('.products-slider-section .product-slider').slick('refresh');
  
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");

 $('.toggle').click(function(j) {

    var dropDown = $(this).closest('.site-footer__item-inner').find('.mobile-toggle');
    $(this).closest('.site-footer__content').find('.mobile-toggle').not(dropDown).slideUp();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.site-footer__content').find('.toggle.active').removeClass('active');
      $(this).addClass('active');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
   
});


$(document).on('click','.select-label', function () {
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown').removeClass('active');
        $(this).parent().addClass('active');
      }
  });
  $(document).on('click','.dropdown-list li', function () {
      $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
      $(this).parents('.dropdown').removeClass('active');
      var variant_id = $(this).data('value');
      $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
  });


if ($(window).width() < 992) {
  $('.product_slider .product-slider').slick({
    arrows: true,
    infinite: false,
    dots: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
}
 $('.single_main_product_image').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.product-single__thumbnails'
});
$('.product-single__thumbnails').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  vertical: true,
  verticalSwiping: true,
  asNavFor: '.single_main_product_image',
  dots: true,
  centerMode: false,
  focusOnSelect: true,
  responsive: [
      {
        breakpoint: 750,
        settings: {
          vertical: false,
          verticalSwiping: false
        }
      }
    ]
});